<template>
  <div class="post-review-item">
    <div class="review review-item-layout sm:items-start relative flex flex-col sm:flex-row items-center w-full pb-2  border-gray-30">
      <div class="w-full text-14px flex flex-wrap gap-x-2 sm:grid sm:gap-x-8
                sm:grid-cols-[72px_37fr_130fr_36px] 
                rounded-8px bg-gray-600">
        <!-- 縮圖列 -->
        <img v-lazy="review.post.cover_image_src" :alt="review.post.title" class="inline-block w-[72px] h-[72px] m-2 rounded-8px overflow-hidden " />
  
        <!-- 標題列 -->
        <div class="post-title  max-w-[230px] sm:max-w-[310px] smd:max-w-md lg:max-w-xl text-14px py-4">
          {{ review.post.title }}
        </div>
        <!-- 評論列 -->
        <div class="post-container flex flex-col w-full px-2 py-4 sm:px-0">
          <div class="review-container flex flex-col w-full" >
            <div class="review-header flex flex-col">
              <div class='reviewer flex'>
                <a :href="`/`+ this.locale +`/p/${review.profile.username}/posts`" class="creator-info">
                  <div class="w-full flex items-center">
                    <div class="flex-shrink-0">
                      <img
                        v-lazy="review.profile.avatar_url"
                        :alt="review.profile.brand_name"
                        class="w-8 h-8 rounded-full"
                      />
                    </div>
                    <div class="pl-4 flex flex-col">
                      <span>
                        {{ review.profile.displayname || review.profile.username }}
                      </span>
                      <span class="text-12px text-gray-150">
                        {{review.created_at}}
                      </span>
                    </div>
                  </div>
                </a>
              </div>
              <div v-if="review.stars"
                   class='review-rating flex items-center my-2 sm:mb-0'>
                <span v-for="rating in 5" :key="rating" class="icon" :class="{'star': review.stars >= rating, 'star-empty': review.stars < rating}"></span>
              </div>
            </div>
            <div class="review-content text-14px mt-2 mb-4 break-words">
              <span v-if="isTruncated && isMobile">{{ truncatedContent }}</span>
              <span v-else>{{ review.content }}</span>
              <!-- "more" btn -->
              <button v-if="isTruncated && !isExpanded && isMobile" @click="toggleContent" class="text-blue-500">
                ...more
              </button>
              <button v-if="isExpanded && isMobile" @click="toggleContent" class="text-blue-500">
                ...less
              </button>
            </div>
            <template v-if="review.images.length > 0">
              <div class="images flex flex-wrap">
                <!-- max image: 5-->
                <img
                  v-for="(image, index) in review.images"
                  :key="index"
                  :src="image.x1_url"
                  class="w-[72px] h-[72px] mr-2 mb-2 rounded-lg"
                  :alt="`Image ${index + 1}`"
                />
              </div>
            </template>

            <div class="likes flex flex-wrap text-gray-20 items-center">
              <img src="../../images/icons/thumbs-up.svg" class="mr-2 w-5 h-5" />
              <span class="text-12px">{{ review.like_count }}</span> 
              <img src="../../images/icons/thumbs-up.svg" class="ml-4 mr-2 w-5 h-5 rotate-180" />
              <span class="text-12px">{{ review.unlike_count }}</span> 
            </div>
          </div>
        </div> 

        <!-- link_to 按鈕 -->
        <a :href="`/posts/${review.post.id}?#review_${review.id}`" class="hidden sm:block review-link flex justify-center py-4" >
          <div class="w-5 h-5 object-contain icon link_to pointer"></div>
        </a>
        <a :href="`/posts/${review.post.id}?#review_${review.id}`" class="sm:hidden flex justify-center items-center absolute top-4 right-1 w-8 h-8" >
          <div class="w-5 h-5 object-contain icon link_to pointer"></div>
        </a>
      </div>
    </div>
  </div>
</template>
<script>
  import { defineComponent, computed } from "vue";
  import { setupSharedLinks } from '../utils/postItemSharedLinks';
  import { getUrlLocale } from '../utils/getUrlLocale';
  import Currency from '../components/Currency.vue';

  export default defineComponent({
    data() {
      return {
        isExpanded: false,
        isMobile: false,
        maxLength: 100,
        locale: ''
      };
    },
    props: ['review'],
    mounted() {
      this.locale = getUrlLocale();
      this.checkViewportWidth();
      window.addEventListener("resize", this.checkViewportWidth);
    },
    beforeDestroy() {
      // 清理監聽器
      window.removeEventListener("resize", this.checkViewportWidth);
    },
    methods: {
      labelClick(e) {
        let btn = document.getElementById(e.target.dataset.for)

        if (btn.checked) {
          btn.checked = false
        } else {
          btn.checked = true
          setupSharedLinks(e.target)
        }
      },
      truncate(text, length, separator = '...') {
        if (!text) return '';
        if (text.length <= length) return text;
        return text.substring(0, length) + separator;
      },
      async savePost() {
        if(this.is_authenticated){
          fetch(`/api/v1/posts/${this.post.id}/save`, {
            method: 'POST',
          })
          .then(response => response.json())
          .then(data => {
            if (data.status === 'saved') {
              this.saved_post = true;
              // GA4: add_to_wishlist
              if (window.trackingEvent) {
                window.trackingEvent.add_to_wishlist({
                  id: this.post.id,
                  title: this.post.title,
                  price: this.post.price,
                  creator: this.post.creator?.brand_name,
                })
              }
            } else {
              this.saved_post = false;
            }
            this.saved_count = data.count;
          })
          .catch(error => {
            console.error('Error saving post:', error);
          });
        } else {
          window.location.href = '/users/sign_in';
        }
      },
      toggleContent() {
        this.isExpanded = !this.isExpanded;
      },
      checkViewportWidth() {
        this.isMobile = window.innerWidth < 560;
      },
    },
    computed: {
      isTruncated() {
        return this.review.content.length > this.maxLength && !this.isExpanded;
      },
      truncatedContent() {
        return this.review.content.substring(0, this.maxLength) + '...';
      }
    },
    components: {
      Currency
    } 
  })
</script>

<style>
.max-w-32 {
  max-width: 128px;
}

@media (min-width: 1280px) {
  .max-w-32 {
    max-width: none;
  }
}

.min-w-32 {
  min-width: 128px;
}
</style>